import { DestroyRef, Injectable } from '@angular/core';
import { API, GeoCullDTO, InventoryFilterDTO, PlayerCullDTO } from '../api/api';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InventoryFieldValueAggregationDTOFrontendEnhanced } from '../../pages/inventory/inventory-list/inventory-list.component';

@Injectable({
  providedIn: 'root',
})
export class InventoryCartService {
  playerCull: PlayerCullDTO;
  geoCull: GeoCullDTO;

  constructor(
    private api: API,
    private destroyRef: DestroyRef
  ) {}

  buildFilterElement(filterElement: InventoryFieldValueAggregationDTOFrontendEnhanced, inventoryType: string): InventoryFilterDTO {
    return {
      path: {
        type: inventoryType,
        field: null,
      },
      values: [filterElement],
    };
  }

  collectElementsForAggregation(filterType: string, filteredValues: any): Promise<any> {
    return new Promise(resolve => {
      const filterWrapper = [];
      for (const val of filteredValues) {
        const filter = {
          path: {
            type: filterType,
            field: null,
          },
          values: [
            {
              value: val.value,
              displayValue: null,
            },
          ],
        };
        const filterEle = {
          filters: [filter],
          whitelistPolygons: null,
          blacklistPolygons: null,
          playerCulls: this.playerCull ? [this.playerCull] : null,
          geoCulls: this.geoCull ? [this.geoCull] : null,
          descriptorId: val.value,
        };
        filterWrapper.push(filterEle);
      }
      this.api
        .ds_rm_Inventory_aggregation(filterWrapper)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: data => {
            for (const e of filteredValues) {
              for (const d of data) {
                if (e.value === Number(d.descriptorId)) {
                  e.report = d;
                }
              }
            }
            resolve(filteredValues);
          },
        });
    });
  }
}
